var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import AutoComplete from 'common/AutoComplete/AutoComplete';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import React from 'react';
import { useQuery } from 'utilities/react-query';
import { GET_ADMIN_ACCOUNT_SEARCH } from 'store/commonReducer/common.action';
import { showError } from 'store/commonReducer/common.action';
import { Box, Backdrop, CircularProgress } from '@mui/material';
import { getFacilityListService } from 'services/addResidentServices/facilityList/facility.service';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { facilitySlugs } from 'globals/global.constants';
//import { toggleLogin } from 'pages/WCPages/Login/Login.action';
import { getFacilityData } from 'pages/WCPages/Admin/CorporateAndFacilities/FacilityManagement/FacilityManagement.action';
import { fetchMultiFacilityList, toggleLogin, updateSelectedFacility } from 'pages/WCPages/Login/Login.action';
import { getCareAgentInfo, saveUserInfo } from 'globals/global.functions';
var AgencyAutoComplete = function (_a) {
    var disabled = _a.disabled;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var _c = React.useState(''), agencySearchInput = _c[0], setAgencySearchInput = _c[1];
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var location = useLocation();
    var urlParams = useParams();
    var _d = React.useState(null), pendingNavigateId = _d[0], setPendingNavigateId = _d[1];
    var options = useAppSelector(function (state) { return state.auth.allFacilityDetails; });
    var selectedAgency = useAppSelector(function (state) { return state.auth.facilityDetails; });
    // Always holds the *latest* selected facility id, read inside async callbacks
    // to guard against a stale/slow fetch for a previously-selected facility
    // overwriting state after the user has already switched again.
    var activeFacilityIdRef = React.useRef(selectedAgency === null || selectedAgency === void 0 ? void 0 : selectedAgency.facility_id);
    React.useEffect(function () {
        activeFacilityIdRef.current = selectedAgency === null || selectedAgency === void 0 ? void 0 : selectedAgency.facility_id;
    }, [selectedAgency === null || selectedAgency === void 0 ? void 0 : selectedAgency.facility_id]);
    React.useEffect(function () {
        if (!open)
            setAgencySearchInput('');
    }, [open]);
    var fetchingFacilityId = selectedAgency === null || selectedAgency === void 0 ? void 0 : selectedAgency.facility_id;
    // Fetch full detail for the *currently active* facility, merge it into
    // auth.facilityDetails, AND push it into corporateAndFacilities so
    // FacilityDetailHeader stays in sync without depending on breadcrumb refetch.
    var isDetailFetching = useQuery({
        queryKey: ['sugarFacilityDetail', fetchingFacilityId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getFacilityListService({
                            facility_ids: JSON.stringify([fetchingFacilityId]),
                        })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a[0]];
                }
            });
        }); },
        enabled: !!fetchingFacilityId,
        cacheTime: 0,
        onSuccess: function (data) {
            if (fetchingFacilityId !== activeFacilityIdRef.current)
                return;
            if (data) {
                // Keep LocalStorage synchronized with the detailed facility configuration
                var careAgentDetails = getCareAgentInfo();
                if (careAgentDetails) {
                    careAgentDetails.facility_info = __assign(__assign(__assign({}, careAgentDetails.facility_info), data), { facility_id: fetchingFacilityId });
                    saveUserInfo(careAgentDetails);
                }
                dispatch(toggleLogin({
                    facilityDetails: __assign(__assign(__assign({}, selectedAgency), data), { facility_id: fetchingFacilityId, facilityId: fetchingFacilityId }),
                }));
                dispatch(getFacilityData(data));
            }
        },
        onError: function (error) {
            if (fetchingFacilityId !== activeFacilityIdRef.current)
                return;
            dispatch(showError(error));
        },
    }).isFetching;
    var selectedValue = React.useMemo(function () {
        var currentId = selectedAgency === null || selectedAgency === void 0 ? void 0 : selectedAgency.facility_id;
        if (!currentId)
            return null;
        var matchedOption = options === null || options === void 0 ? void 0 : options.find(function (item) { return item.facilityId === currentId; });
        // Fall back to a synthetic option built from Redux facilityDetails itself
        // (covers the window before `allFacilityDetails` has loaded, e.g. right
        // after a reload) — still Redux-derived, never component-local.
        return (matchedOption || {
            facilityId: currentId,
            facilityName: selectedAgency.facility_name,
        });
    }, [options, selectedAgency]);
    var handleChange = function (event, newValue) {
        dispatch({
            type: GET_ADMIN_ACCOUNT_SEARCH,
            payload: {
                accountKey: 'cwMemberAccount',
                paramKey: 'selectedAgencies',
                paramValue: newValue ? [newValue] : [],
            },
        });
        if (newValue) {
            // Update the ref synchronously (before the redux dispatch/re-render even
            // lands) so any in-flight fetch for the *previous* facility is marked
            // stale the instant a new one is picked.
            activeFacilityIdRef.current = newValue.facilityId;
            // Cleanly update Redux and LocalStorage using the new action creator
            dispatch(updateSelectedFacility(newValue.facilityId, newValue.facilityName));
            // Refresh the option list per requirement
            dispatch(fetchMultiFacilityList());
        }
        setPendingNavigateId((newValue === null || newValue === void 0 ? void 0 : newValue.facilityId) || null);
    };
    React.useEffect(function () {
        if (!pendingNavigateId)
            return;
        var currentFacilityId = urlParams[facilitySlugs.facilityHomePage];
        if (currentFacilityId && currentFacilityId !== pendingNavigateId) {
            navigate(location.pathname.replace(currentFacilityId, pendingNavigateId));
        }
        setPendingNavigateId(null);
    }, [pendingNavigateId]);
    return (_jsxs(_Fragment, { children: [_jsx(AutoComplete, { id: 'autocompleteAgencies', open: open, placeholder: 'Select Facility', onOpen: function () { return setOpen(true); }, onClose: function () { return setOpen(false); }, value: selectedValue, onChange: handleChange, getOptionDisabled: function () { return false; }, onInputChange: function (event, newValue, reason) {
                    if (reason === 'input')
                        setAgencySearchInput(newValue);
                }, disabled: disabled, isOptionEqualToValue: function (option, value) {
                    return option.facilityId === (value === null || value === void 0 ? void 0 : value.facilityId);
                }, getOptionLabel: function (option) { return option.facilityName || ''; }, loading: false, filterOptions: function (x) { return x; }, renderOption: function (props, option) { return (_createElement(Box, __assign({ component: 'li' }, props, { key: option.facilityId }), option.facilityName)); }, options: options }), _jsx(Backdrop, { sx: { color: '#fff', zIndex: function (theme) { return theme.zIndex.drawer + 999; } }, open: isDetailFetching, children: _jsx(CircularProgress, { color: 'inherit' }) })] }));
};
export default AgencyAutoComplete;
